
export default {
  name: 'ComponentsRouter',
  values: {},
  meta: {
    extendable: false,
  },
}
